<template>
  <div class="bg-white">
    <CommHeader />
    <CommSwipe :dataList="swipeDataList" />
    <div class="container">
      <div class="bottom-border common-padding-bottom">
        <div class="common-padding-top row">
          <div class="col col-12 col-md-8 col-lg-8 ">
            <div>
              <span><img class="common-img-icon-m" :src="require('images/home/scanpay.png')"></span>
              <span class="font-20 text-middle common-margin-left-1">扫码支付</span>
            </div>
            <div class="common-letter-spacing-2 font-12">
              <p class="font-14 common-margin-top-1"><span class="common-margin-left"></span>扫码支付是指商家提供收款码给消费者扫码完成付款。</p>
              <div class="common-margin-top-2">应用场景有：</div>
              <div class="common-margin-top-1">1.线下门店：商家贴码、摆放立牌，用户扫码付款。</div>
              <div class="common-margin-top-1">2.PC网站场景：商家在网页上显示收款码，用户拿出手机扫屏幕上的二维码进行付款。</div>
            </div>
            <div class="common-margin-top-2">
              <div class="font-12">使用教程：</div>
              <div class="common-margin-top-1">
                <img class="col-10" :src="require('images/home/scan-exp.png')" />
              </div>
            </div>
          </div>
          <div class="col col-12 col-md-4 col-lg-4 text-top">
            <div class="common-margin-top-1 text-center">
              <b-button v-b-modal.modal-1 class="color-black common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14">接入申请</b-button>
              <router-link tag="button" :to="{path:'/interface/sm'}" class="common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14 common-margin-left">技术文档</router-link>
            </div>
            <div class="common-margin-top radius-shadow-0-2 common-padding-2 bg-tag-img-1 font-12">
              <div class="font-14 font-weight-bold common-letter-spacing-1">场景对话</div>
              <div class="common-margin-top-2">一天，小花（消费者）吃了一碗面，准备买单。</div>
              <div class="common-margin-top-2">
                <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                <span class="common-padding-left-1">小花：”老板，买单。”</span>
              </div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-man-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">老板：“20元，扫那个码（老板指着墙上的收款码）。”</span>
              </div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">小花：“支付了（打开微信扫码支付成功页面 并把结果 给你老板看）。”</span>
              </div>
              <div class="font-12 common-margin-top-2">（以上就是扫码支付线下门店场景对话）</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white bottom-border common-padding-bottom">
        <div class="common-padding-top row">
          <div class="col col-12 col-md-8 col-lg-8">
            <div>
              <span><img class="common-img-icon-m" :src="require('images/home/barcode.png')"></span>
              <span class="font-20 text-middle common-margin-left-1">条码支付</span>
            </div>
            <div class="common-letter-spacing-2 font-12">
              <p class="font-14 common-margin-top-1"><span class="common-margin-left"></span>条码支付是指用户展示钱包内的“付款码”给商户系统扫描后直接完成支付。</p>
              <div class="common-margin-top-2">应用场景有：</div>
              <div class="common-margin-top-1 ">当面付，商家拿条码枪、自助收银机，刷脸设备机、POS机等</div>
            </div>
            <div class="common-margin-top-2">
              <div class="font-12">使用教程：</div>
              <div class="common-margin-top-1">
                <img class="col-8" :src="require('images/home/barcode-exp.png')" />
              </div>
            </div>
          </div>
          <div class="col col-12 col-md-4 col-lg-4 text-top">
            <div class="common-margin-top-1 text-center">
              <b-button v-b-modal.modal-1 class="color-black common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14">接入申请</b-button>
              <router-link tag="button" :to="{path:'/interface/tm'}" class="common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14 common-margin-left">技术文档</router-link>
            </div>
            <div class="common-margin-top radius-shadow-0-2 common-padding-2 bg-tag-img-1 font-12">
              <div class="font-14 font-weight-bold common-letter-spacing-1">场景对话</div>
              <div class="common-margin-top-2">一天，小花（消费者）去超市买了一杯泡面，走到收银台前，收银员录入泡面。</div>
              <div class="common-margin-top-2">
                <img class="common-img-icon-sm" :src="require('images/home/user-man-icon.png')">
                <span class="common-padding-left-1">收银员：“4元，现金还是扫码？”</span>
              </div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">小花：“扫码”</span>
              </div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-man-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">收银员：“这里扫（收银员指着桌上的扫码枪）”</span>
              </div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">小花打开支付宝付款码贴上去，支付成功。</span>
              </div>
              <div class="font-12 common-margin-top-2">（以上就是条码支付线下门店场景对话）</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white bottom-border common-padding-bottom">
        <div class="common-padding-top row">
          <div class="col col-12 col-md-8 col-lg-8">
            <div>
              <span><img class="common-img-icon-m" :src="require('images/home/wechat.png')"></span>
              <span class="font-20 text-middle common-margin-left-1">公众号支付/生活号支付</span>
            </div>
            <div class="common-letter-spacing-2 font-12">
              <div class="font-14 common-margin-top-1">
                <p class="common-line-height-2-5"><span class="common-margin-left"></span>公众号支付顾名思义在微信开发的公众号里面支付，离不开微信，否则显示请在微信里面打开；<br />
                  生活号支付顾名思义在支付宝内打开才能使用</p>
              </div>
              <div class="common-margin-top-2">应用场景有：</div>
              <div class="common-margin-top-1 ">微信公众号/支付宝生活号：公众号商城/生活号商城，用户在微信或者支付宝APP内打开商家的公众号</div>
              <div class="common-margin-top-1 ">或者生活号程序支付</div>
            </div>
            <div class="common-margin-top-2">
              <div class="font-12">使用教程：</div>
              <div class="common-margin-top-1">
                <img class="col-8" :src="require('images/home/wechat-exp.png')" />
              </div>
            </div>
          </div>
          <div class="col col-12 col-md-4 col-lg-4 text-top">
            <div class="common-margin-top-1 text-center">
              <b-button v-b-modal.modal-1 class="color-black common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14">接入申请</b-button>
              <router-link tag="button" :to="{path:'/interface/gzh'}" class="common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14 common-margin-left">技术文档</router-link>
            </div>
            <div class="common-margin-top radius-shadow-0-2 common-padding-2 bg-tag-img-1 font-12">
              <div class="font-14 font-weight-bold common-letter-spacing-1">场景对话</div>
              <div class="common-margin-top-2">一天，小花收到老板推荐的公众号，打开一看是卖文具的商城。</div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-man-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">老板：“公司文具用完了，这个公众号商城买文具比较划算”</span>
              </div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                <span class="common-padding-left-1">小花：“好的，已经选好了，您付款吧。” </span>
              </div>
              <div class="common-margin-top-1 common-margin-left">(小花把付款页面发给了老板)</div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-man-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">老板：“付不了款（老板复制付款链接在浏览器打开）”</span>
              </div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">小花：“老板，您需要在微信里面打开链接才能正常付款” 小花把付款页面发给了老板。</span>
              </div>
              <div class="font-12 common-margin-top-2">（以上就是公众号支付场景对话）</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white bottom-border common-padding-bottom">
        <div class="common-padding-top row">
          <div class="col col-12 col-md-8 col-lg-8">
            <div>
              <span><img class="common-img-icon-m" :src="require('images/home/mini.png')"></span>
              <span class="font-20 text-middle common-margin-left-1">小程序支付</span>
            </div>
            <div class="common-letter-spacing-2 font-12">
              <p class="font-14 common-margin-top-1"><span class="common-margin-left"></span>小程序支付顾名思义在微信开发的小程序里面支付，离不开微信，否则打开异常。</p>
              <div class="common-margin-top-2">应用场景有：</div>
              <div class="common-margin-top-1">1.小程序商城;用户在微信小程序或者支付宝小程序内打开商家小程序，下单进行支付。 </div>
              <div class="common-margin-top-1">2.APP跳转小程序支付：在APP里面唤起小程序，再做小程序支付。</div>
            </div>
            <div class="common-margin-top-2">
              <div class="font-12">使用教程：</div>
              <div class="common-margin-top-1">
                <img class="col-9" :src="require('images/home/mini-exp.png')" />
              </div>
            </div>
          </div>
          <div class="col col-12 col-md-4 col-lg-4 text-top">
            <div class="common-margin-top-1 text-center">
              <b-button v-b-modal.modal-1 class="color-black common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14">接入申请</b-button>
              <router-link tag="button" :to="{path:'/interface/xcx'}" class="common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14 common-margin-left">技术文档</router-link>
            </div>
            <div class="common-margin-top radius-shadow-0-2 common-padding-2 bg-tag-img-1 font-12">
              <div class="font-14 font-weight-bold common-letter-spacing-1">场景对话</div>
              <div class="common-margin-top-2">一天，小花收到老板推荐的小程序，打开一看是卖文具的商城。</div>
              <div class="common-margin-top-2">
                <img class="common-img-icon-sm" :src="require('images/home/user-man-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">老板：“公司文具用完了，这个公众号商城买文具比较划算”</span>
              </div>
              <div class="font-10 common-margin-top-1">
                <img class="common-img-icon-s" :src="require('images/home/user-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">小花：“好的（小花选好后直接在小程序支付）” 小花把付款页面发给了老板。</span>
              </div>
              <div class="font-12 common-margin-top-2">（以上就是小程序支付场景对话）</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white bottom-border common-padding-bottom">
        <div class="common-padding-top row">
          <div class="col col-12 col-md-8 col-lg-8">
            <div>
              <span><img class="common-img-icon-m" :src="require('images/home/h5.png')"></span>
              <span class="font-20 text-middle common-margin-left-1">H5支付</span>
            </div>
            <div class="common-letter-spacing-2 font-12">
              <p class="font-14 common-margin-top-1"><span class="common-margin-left"></span>H5支付是指商户在微信/支付宝客户端外的移动端网页展示商品或服务，用户在前述页面确认使用微信/支付宝支付时，商户发起本服务呼起支付宝/微信客户端进行支付。</p>
              <div class="common-margin-top-2">应用场景有：</div>
              <div class="common-margin-top-1">主要用于触屏版的手机浏览器请求微信/支付宝支付的场景。可以方便的从外部浏览 器唤起微信/支付宝支付。</div>
            </div>
            <div class="common-margin-top-2">
              <div class="font-12">使用教程：</div>
              <div class="common-margin-top-1">
                <img class="col-10" :src="require('images/home/h5-exp.png')" />
              </div>
            </div>
          </div>
          <div class="col col-12 col-md-4 col-lg-4 text-top">
            <div class="common-margin-top-1 text-center">
              <b-button v-b-modal.modal-1 class="color-black common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14">接入申请</b-button>
              <router-link tag="button" :to="{path:'/interface/sm'}" class="common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14 common-margin-left">技术文档</router-link>
            </div>
            <div class="common-margin-top radius-shadow-0-2 common-padding-2 bg-tag-img-1 font-12">
              <div class="font-14 font-weight-bold common-letter-spacing-1">场景对话</div>
              <div class="common-margin-top-2">一天，小花收到老板发的网址，浏览器查看是文具商城。</div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-man-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">老板：“公司文具用完了，这个公众号商城买文具比较划算”。</span>
              </div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">小花：“好的”（小花复制链接在浏览器打开了，选完商品，发起支付），发现界面跳回了微信，在微信里面完成了支付。 </span>
              </div>
              <div class="font-12 common-margin-top-2">（以上就是H5支付场景对话）</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white bottom-border common-padding-bottom">
        <div class="common-padding-top row">
          <div class="col col-12 col-md-8 col-lg-8">
            <div>
              <span><img class="common-img-icon-m" :src="require('images/home/quickpay.png')"></span>
              <span class="font-20 text-middle common-margin-left-1">快捷支付</span>
            </div>
            <div class="common-letter-spacing-2 font-12">
              <p class="font-14 common-margin-top-1"><span class="common-margin-left"></span>快捷支付是输入卡面信息及持卡人身份信息，根据安全规则可通过验证银行预留的手机接收校验码完成签约和支付，是一种便捷、快速、安全的付款方式。</p>
              <div class="common-margin-top-2">应用场景有：</div>
              <div class="common-margin-top-1">主要用于触屏版的手机浏览器请求微信/支付宝支付的场景。可以方便的从外部浏览 器唤起微信/支付宝支付。</div>
            </div>
            <div class="common-margin-top-2">
              <div class="font-12">使用教程：</div>
              <div class="common-margin-top-1">
                <img class="col-10" :src="require('images/home/quickpay-exp.png')" />
              </div>
            </div>
          </div>
          <div class="col col-12 col-md-4 col-lg-4 text-top">
            <div class="common-margin-top-1 text-center">
              <b-button v-b-modal.modal-1 class="color-black common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14">接入申请</b-button>
              <router-link tag="button" :to="{path:'/interface/kj'}" class="common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14 common-margin-left">技术文档</router-link>
            </div>
            <div class="common-margin-top radius-shadow-0-2 common-padding-2 bg-tag-img-1 font-12">
              <div class="font-14 font-weight-bold common-letter-spacing-1">场景对话</div>
              <div class="common-margin-top-2">一天，小花收到老板推荐的小程序，打开一看是卖文具的商城。</div>
              <div class="common-margin-top-2">
                <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                <span class="common-padding-left-1">小花：”老板，买单。”</span>
              </div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-man-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">老板：“微信余额不够，选择了银联支付，绑卡后进行了支付。”</span>
              </div>
              <div class="font-12 common-margin-top-2">（以上就是快捷支付场景对话）</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white bottom-border common-padding-bottom">
        <div class="common-padding-top row">
          <div class="col col-12 col-md-8 col-lg-8">
            <div>
              <span><img class="common-img-icon-m" :src="require('images/home/sub-account.png')"></span>
              <span class="font-20 text-middle common-margin-left-1">分账系统</span>
            </div>
            <div class="common-letter-spacing-2 font-12">
              <p class="font-14 common-margin-top-1 common-line-height-2-5"><span class="common-margin-left"></span><!--广东快付-->银典科技支付与多家银行与支付机构合作， 为平台型企业提供收款、付款、账户管理、 资金管理与一体的分账合规解决方案，
                统一把控信息流、资金流做到双流合一，规避二清拥抱合规，实现自动化高效分账。</p>
              <div class="common-margin-top-2">应用场景有：</div>
              <div class="common-margin-top-1 ">1.商城：实现供货商、业务员、快递公司等多角色实时分钱。</div>
              <div class="common-margin-top-1 ">2.总分公司利润分摊。</div>
              <div class="common-margin-top-1 ">3.平台各方利润分摊。</div>
            </div>
            <div class="common-margin-top-2">
              <div class="font-12">使用教程：</div>
              <div class="common-margin-top-1">
                <img class="col-10" :src="require('images/home/sub-account-exp.png')" />
              </div>
            </div>
          </div>
          <div class="col col-12 col-md-4 col-lg-4 text-top">
            <div class="common-margin-top-1 text-center">
              <b-button v-b-modal.modal-1 class="color-black common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14">接入申请</b-button>
              <router-link tag="button" :to="{path:'/interface/fz'}" class="common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14 common-margin-left">技术文档</router-link>
            </div>
            <div class="common-margin-top radius-shadow-0-2 common-padding-2 bg-tag-img-1 font-12">
              <div class="font-14 font-weight-bold common-letter-spacing-1">
                <span :class="dialog1?'bottom-border-yellow':''" @click="dialog1=!dialog1" class="common-padding-bottom-0-5 cursor-pointer">场景对话1</span>
                <span :class="!dialog1?'bottom-border-yellow':''" @click="dialog1=!dialog1" class="common-margin-left-1 common-padding-bottom-0-5 cursor-pointer">场景对话2</span>
              </div>
              <div v-show="dialog1">
                <div class="common-margin-top-2">小花是B2C商城公司财务，公司做了B2C商城。</div>
                <div class="common-margin-top-2">
                  <img class="common-img-icon-sm" :src="require('images/home/user-man-icon.png')">
                  <span class="common-padding-left-1 common-line-height-2-5">老板：“我们上线了C2C业务，商户的钱都用我们对公账户收款，以后每天需要把开店的商家的钱结算给他们。”</span>
                </div>
                <div class="common-margin-top-1">
                  <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                  <span class="common-padding-left-1 common-line-height-2-5">小花：“  金额巨大哦，不好做账，而且，据说这种叫二清，是违规的，又被罚款风险。” </span>
                </div>
                <div class="common-margin-top-1">
                  <img class="common-img-icon-sm" :src="require('images/home/user-man-icon.png')">
                  <span class="common-padding-left-1 common-line-height-2-5">老板：“哦？那怎么办？”</span>
                </div>
                <div class="common-margin-top-1">
                  <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                  <span class="common-padding-left-1 common-line-height-2-5">小花：“  上次对接的<!--广东快付-->银典科技支付公司分账系统可以解决这个问题。我们让商家在自己收款，把平台服务费分账给我们。” </span>
                </div>
                <div class="font-12 common-margin-top-2">（以上便是分账场景对话。）</div>
              </div>
              <div v-show="!dialog1" class="font-12">
                <div class="common-margin-top-2">小华是B2C商城公司财务，老板让小华每日结算商城推广费和快递费。</div>
                <div class="common-margin-top-2">
                  <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                  <span class="common-padding-left-1 common-line-height-2-5">小花：”老板，今日收款100万，利润10万，快递费：申通300元，韵达500元，顺丰100元，圆通500元，中通1000元等，推广费张三10元，李四1000元，王五200元，……”</span>
                </div>
                <div class="common-margin-top-1">
                  <img class="common-img-icon-sm" :src="require('images/home/user-man-icon.png')">
                  <span class="common-padding-left-1 common-line-height-2-5">老板：“给他们转账吧，仔细点，别转错了哈。”</span>
                </div>
                <div class="common-margin-top-1">
                  <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                  <span class="common-padding-left-1 common-line-height-2-5">小花：“我太难了。”</span>
                </div>
                <div class="common-margin-top-1">
                  <img class="common-img-icon-sm" :src="require('images/home/user-man-icon.png')">
                  <span class="common-padding-left-1 common-line-height-2-5">老板：“听说<!--广东快付-->银典科技有分账系统，可以逐笔在收款时完成分账。可以做到支付100元，推广费张三10块，李四2亏块，快递费申通5元，实时分账哦。”</span>
                </div>
                <div class="common-margin-top-1">
                  <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                  <span class="common-padding-left-1 common-line-height-2-5">小花：“赶紧对接。”</span>
                </div>
                <div class="font-12 common-margin-top-2">（以上便是分账场景对话。）</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white bottom-border common-padding-bottom">
        <div class="common-padding-top row">
          <div class="col col-12 col-md-8 col-lg-8">
            <div>
              <span><img class="common-img-icon-m" :src="require('images/home/wallet.png')"></span>
              <span class="font-20 text-middle common-margin-left-1">商家钱包</span>
            </div>
            <div class="common-letter-spacing-2 font-12">
              <p class="font-14 common-margin-top-1"><span class="common-margin-left"></span><!--广东快付-->银典科技支付与多家银行与支付机构合作， 为平台型企业提供收款、结算功能，用于 多层级用户提取分润。</p>
              <div class="common-margin-top-2">应用场景有：</div>
              <div class="common-margin-top-1 ">层级分润提现：平台直推、间推利润提现代付。</div>
            </div>
            <div class="common-margin-top-2">
              <div class="font-12">使用教程：</div>
              <div class="common-margin-top-1">
                <img class="col-10" :src="require('images/home/wallet-exp.png')" />
              </div>
            </div>
          </div>
          <div class="col col-12 col-md-4 col-lg-4 text-top">
            <div class="common-margin-top-1 text-center">
              <b-button v-b-modal.modal-1 class="color-black common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14">接入申请</b-button>
              <router-link tag="button" :to="{path:'/interface/qb'}" class="common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 bg-yellow-2 radius-0-5 border-0 font-14 common-margin-left">技术文档</router-link>
            </div>
            <div class="common-margin-top radius-shadow-0-2 common-padding-2 bg-tag-img-1 font-12">
              <div class="font-14 font-weight-bold common-letter-spacing-1">场景对话</div>
              <div class="common-margin-top-2">公司财务小花， 缓缓地推开老板办公室的门。</div>
              <div class="common-margin-top-2">
                <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">小花：“  老板，有两个消息，一个坏消息，一个好消息，您想先听哪一个？” </span>
              </div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-man-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">老板：“先讲好消息。”</span>
              </div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">小花：“  今天是代理商分润结算日，我查了下系统，我们代理翻了几倍，有几万了。” </span>
              </div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-man-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">老板：“不错，按这速度距离上市不远了，坏消息呢？”</span>
              </div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">小花：“  大家的分润今天结算完不成，人工打款太慢了，还容易出错。” </span>
              </div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-man-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">老板：“听说<!--广东快付-->银典科技支付公司有商家钱包，我们把钱充进去，让会员自己提现。”</span>
              </div>
              <div class="common-margin-top-1">
                <img class="common-img-icon-sm" :src="require('images/home/user-icon.png')">
                <span class="common-padding-left-1 common-line-height-2-5">小花：“  太好了，不用加班了。” </span>
              </div>
              <div class="font-12 common-margin-top-2">（以上就是商家钱包场景对话）</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ok-only id="modal-1" title="联系方式">
      <div class="my-4">
        <div>
            地址：广州市天河区林和西路9号耀中广场B座1012室
        </div>
        <div>
            邮箱：wangtao@yindiankeji.com
        </div>
        <div>
            电话：<a href="tel://4000-468-365">4000-468-365</a>
        </div>
      </div>
    </b-modal>
    <CommBrand />
    <CommFooter />
  </div>
</template>

<script>
import CommHeader from '@/components/CommHeader'
import CommSwipe from '@/components/CommSwipe'
import CommBrand from '@/components/CommBrand'
import CommFooter from '@/components/CommFooter'
export default {
  name: 'home',
  components: {
    CommHeader,
    CommSwipe,
    CommBrand,
    CommFooter
  },
  data () {
    return {
      dialog1: false,
      swipeDataList: [{img: require('images/home/sw-img1.jpg'),
        caption: '快速接入',
        url: '/interface',
        describe: '1、有写好的demo，照抄就能行。支持Java、PHP、Python、C#等主流开发语言。' +
          '2、有专业技术人员远程或上门提供技术支持。' +
          '3、有清晰的开发文档接口。' +
          '4、有一群漂亮小妹妹24小时为您解答业务问题。'
      }, {img: require('images/home/sw-img1.jpg'),
        caption: '代理百亿补贴',
        describe: '1、无论您有没有技术都可以申请代理，一起传播支付。' +
          '2、我们分您万2~万10的补贴。以一个商家日交易100万为例，以万5为例，日收益500，若有100家商家，日收益5万。不要说100商家太难，每日一家也就干一个季度，之后躺赚吧。\n' +
          '3、如果您已经够强大，咱们联盟一起争取更多上游的优惠政策。'
      }, {img: require('images/home/sw-img1.jpg'),
        caption: '新零售生态',
        url: '/product/xls',
        describe: '完整的新零售生态系统，刷脸收款、扫码收款、打折、全返、返券、返矿、返......  您能想到的我们都有'
      }]
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/Home.vue